import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable({
	providedIn: 'root'
})
export class TipoDespesaService {
	private data = null;
	private url = environment.serviceApi;

	constructor(public http: Http) { }

	getTiposDespesa(ordem=null) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/tiposdespesa' + (ordem? '/ordem/' + ordem : ''))
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	getTipoDespesa(id) {
		return new Promise((resolve, reject) => {
			this.http.get(this.url + '/tiposdespesa/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	criaTipoDespesa(data) {
		return new Promise((resolve, reject) => {
			this.http.post(this.url + '/tiposdespesa', {
				tipo_despesa_nome: data.tipo_despesa_nome,
				grupo_despesa_id: data.grupo_despesa_id,
				categoria_despesa_id: data.categoria_despesa_id,
				tipo_despesa_periodo_aviso: data.tipo_despesa_periodo_aviso,
				tipo_despesa_km_aviso: data.tipo_despesa_km_aviso,
				produtos: data.tipo_despesa_produto
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	editaTipoDespesa(data) {
		return new Promise((resolve, reject) => {
			this.http.put(this.url + '/tiposdespesa/' + data.tipo_despesa_id, {
				tipo_despesa_nome: data.tipo_despesa_nome,
				grupo_despesa_id: data.grupo_despesa_id,
				categoria_despesa_id: data.categoria_despesa_id,
				tipo_despesa_periodo_aviso: data.tipo_despesa_periodo_aviso,
				tipo_despesa_km_aviso: data.tipo_despesa_km_aviso,
				produtos: data.tipo_despesa_produto
			})
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}

	apagaTipoDespesa(id) {
		return new Promise((resolve, reject) => {
			this.http.delete(this.url + '/tiposdespesa/' + id)
			.map(res => res.json())
			.subscribe(data => {
				this.data = data;
				resolve(this.data);
			},
			err => {
				reject(err);
			});
		});
	}
}
